<template>
  <div>
    <el-tabs v-model="activeName">
      <el-tab-pane label="动态审核开启关闭" name="DynamicAudit">
        <DynamicAudit></DynamicAudit>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>

import DynamicAudit from '../../../components/sys/basic/DynamicAudit'

export default {
  name: 'SysBasic',
  data () {
    return {
      activeName: 'DynamicAudit',

    }
  },
  components: {
    DynamicAudit
  }
}
</script>

<style scoped>

</style>
